import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Button from "../../components/Button";
import TableComponent from "../../components/TableComponent";
import { getActivitiesTraining, deleteActivitiesTrainingById } from "../../api/activities-training";
import Confirm from "../../components/Confirm";

//import ActivitiesTrainingTable from "../../features/activities-training";
//import EditActivitiesTraining from "../../features/activities-training/edit";

const ActivitiesTrainingTable = ({ match, history }) => {
  const { t } = useTranslation();
  const [activitiesTraining, setActivitiesTraining] = useState(null);

  const [selectedOperationId, setSelectedOperationId] = useState(null);
  const [isDeleteModalShow, setIsDeleteModalShow] = useState(false);
  const [refresh, setRefresh] = useState(1);

  function showDeleteModal(id) {
    setSelectedOperationId(id);
    setIsDeleteModalShow(true);
  }

  async function confirmDeleteModal(isConfirmed) {
    if (isConfirmed) {
      await deleteActivitiesTrainingById(selectedOperationId);
    }
    setIsDeleteModalShow(false);
    setRefresh(refresh * -1);
  }

  useEffect(() => {
    (async () => {
      const res = await getActivitiesTraining();

      setActivitiesTraining(res);
    })();
  }, [refresh]);

  return (
    <>
      <Typography variant="h4">{t("activities_training.title")}</Typography>
      {activitiesTraining ? (
        <TableComponent
          TopComponent={
            <Button size="small" onClick={() => history.push(`/activities-training/add`)}>
              <PostAddIcon />
              {t("activities_training.add_action")}
            </Button>
          }
          search={["name"]}
          header={[
            { title: t("id"), style: { width: "5%" } },
            { title: t("name") },
            { title: t("status") },
            { title: t("activities_training.observable") },
            { title: t("actions") },
          ]}
          items={activitiesTraining}
          renderChildren={(ps) => (
            <TableRow key={ps.id}>
              <TableCell>{ps.id}</TableCell>
              <TableCell>{ps.name}</TableCell>
              <TableCell>{ps.status === "active" ? t("active") : t("not_active")}</TableCell>
              <TableCell>
                {ps.observable.map((o) => (
                  <li key={`${ps.id}-${o.id}`}>
                    {o.id} - {o.name}
                  </li>
                ))}
              </TableCell>

              <TableCell>
                <Button
                  icon={<EditIcon />}
                  onClick={() => history.push(`/activities-training/edit/${ps.id}`)}
                  title={t("activities_training.edit_action")}
                />
                <Button
                  icon={<DeleteForeverIcon />}
                  onClick={() => showDeleteModal(ps.id)}
                  title={t("activities_training.delete_action")}
                />
              </TableCell>
            </TableRow>
          )}
        />
      ) : null}

      {isDeleteModalShow && selectedOperationId ? (
        <Confirm title={t("activities_training.delete_action")} onConfirm={confirmDeleteModal}>
          <p>{t("activities_training.delete_confirm")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default ActivitiesTrainingTable;
